import React from "react";
import { Grid } from "@mui/material";
import Header from "./header";


export default function Layout({ children }) {
    return (
        <Grid>
            <Header />
            {children}
        </Grid>
    )
}